import React, { useState } from 'react'
import { FormGrid, FormGroup, InfoLink, Label, Select } from '../../style'
import { Info } from 'lucide-react'

const MainInfosSection = () => {
    const formData = {
    suppliers: [{ name: "Fornecedor LTDA" }],
    sellers: [{ name: "Vendedor S/A" }],
    clients: [{ name: "Cliente do Brasil ME" }],
    orderTypes: [{ name: "Venda" }],
    paymentTerms: [{ name: "12x sem juros no boleto" }],
    shippingTypes: [{ name: "Transportes S/A" }],
    trackingCodes: [{ name: "AG987654321BR" }],
    attachments: [{ name: "Pedido_1.docx" }],
  }
  
  return(
    <>
      <FormGrid>
        <FormGroup>
          <Label>Fornecedor</Label>
          <Select>
            <option>{formData.suppliers[0].name}</option>
          </Select>
          <InfoLink>
            <Info size={16} />
            <span>Mais informações</span>
          </InfoLink>
        </FormGroup>
        <FormGroup>
          <Label>Vendedor</Label>
          <Select>
            <option>{formData.sellers[0].name}</option>
          </Select>
          <InfoLink>
            <Info size={16} />
            <span>Mais informações</span>
          </InfoLink>
        </FormGroup>
        <FormGroup>
          <Label>Cliente</Label>
          <Select>
            <option>{formData.clients[0].name}</option>
          </Select>
          <InfoLink>
            <Info size={16} />
            <span>Mais informações</span>
          </InfoLink>
        </FormGroup>
      </FormGrid>
    </>
  )
}

export default MainInfosSection